


















import Vue from "vue";
import Component from "vue-class-component";

const RatingProps = Vue.extend({
  props: {
    numberOfStars: Number
  }
});

@Component
export default class Rating extends RatingProps {
  numberOfSelectedStar = 0;
  onClickStar(n: number) {
    this.numberOfSelectedStar = n;
    this.$emit("rated", n);
  }
  setRating(n: number) {
    this.numberOfSelectedStar = n;
    this.$emit("rated", n, true);
  }
}
